import { CapaConnectFileUpload } from '@api/rest';
import { CustomizedButton } from '@components/Customized';
import { IconButton } from '@material-ui/core';
import React from 'react';
import { useRef } from 'react';
import { FileUploadOutlinedIcon } from './assets';
import useStyles from './useStyles';

interface Props {
  matches: boolean;
  currentPath?: string;
  onRefetchMyDrive: () => void;
}

const ConnectDriveUploadButton = ({
  matches,
  currentPath,
  onRefetchMyDrive
}: Props) => {
  const classes = useStyles();
  const inputRef = useRef<HTMLInputElement>(null);

  const onUpdate = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    if (files && files.length > 0) {
      for (let index = 0; index < files.length; index++) {
        const formData = new FormData();

        formData.append('files', files.item(index)!);
        formData.append('pathId', currentPath ?? '');

        await CapaConnectFileUpload('/connect', formData);

        await onRefetchMyDrive();
      }
    }
  };

  const onClick = () => {
    if (inputRef.current) {
      inputRef.current.click();
    }
  };

  return (
    <div className={classes['Connect-Drive-Upload-Button-root']}>
      <input ref={inputRef} multiple type="file" onChange={onUpdate} />

      {matches ? (
        <IconButton onClick={onClick}>
          <img
            width={matches ? 24 : 16}
            height={matches ? 24 : 16}
            src={FileUploadOutlinedIcon}
            alt=""
          />
        </IconButton>
      ) : (
        <CustomizedButton
          variant="text"
          color="primary"
          startIcon={
            <img width={16} height={16} src={FileUploadOutlinedIcon} alt="" />
          }
          onClick={onClick}
        >
          파일 업로드
        </CustomizedButton>
      )}
    </div>
  );
};

export default ConnectDriveUploadButton;
